import { render, staticRenderFns } from "./DetalhesProduto.vue?vue&type=template&id=15aacec6&scoped=true"
import script from "./DetalhesProduto.vue?vue&type=script&lang=js"
export * from "./DetalhesProduto.vue?vue&type=script&lang=js"
import style0 from "./DetalhesProduto.vue?vue&type=style&index=0&id=15aacec6&prod&scoped=true&lang=css"
import style1 from "./DetalhesProduto.vue?vue&type=style&index=1&id=15aacec6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aacec6",
  null
  
)

export default component.exports